import React from "react";
import { Helmet } from "react-helmet";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import BackButton from "../../backButton";
import tamanit1 from "../../../assets/images/tamanit1.jpeg";
import tamanit2 from "../../../assets/images/tamanit2.jpeg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Tamanit = () => {
  return (
    <div className="inner-section" id="tamanit">
      <Helmet>
        <title>פטרידע - הפטריה תמנית</title>
        <meta
          name="description"
          content="הפטריה תמנית - Octospora: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="tamanit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="tamanitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="tamanitText2" />
          </p>
          <p>
            <MultiLingualContent contentID="tamanitText3" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={tamanit1} alt="תמנית" />
              <p>
                <MultiLingualContent contentID="tamanitImg1" />
              </p>
            </div>
          </div>
          <p>
            <MultiLingualContent contentID="tamanitText4" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={tamanit2} alt="תמנית" />
              <p>
                <MultiLingualContent contentID="tamanitImg2" />
              </p>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default Tamanit;
